import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';

@Component({
  selector: 'weaccess-postal-code-input',
  templateUrl: './postal-code-input.component.html',
  styleUrls: ['./postal-code-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PostalCodeInputComponent),
      multi: true,
    },
  ],
})
export class PostalCodeInputComponent implements ControlValueAccessor, OnInit {
  postalCodeForm: FormGroup;
  @Input() isClearForm: any;
  @Output() validationStatus: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor(private formBuilder: FormBuilder) {
    this.postalCodeForm = this.formBuilder.group({
      zip: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
      zipExtension: ['', [Validators.minLength(4), Validators.maxLength(4)]],
    });
  }

  ngOnInit() {
    /** Postal code field change value detection event subscribe method */
    this.postalCodeForm.valueChanges.subscribe(() => {
      this.onChange(this.postalCodeForm.value.zip + (this.postalCodeForm.value.zipExtension ? `-${this.postalCodeForm.value.zipExtension}` : ''));
    });
  }

  ngOnChanges() {
    if (this.isClearForm) {
      this.postalCodeForm.reset();
    }
  }

  onChange: any = () => {
  };
  onTouch: any = () => { };

  /** Auto populate values back into form fields functionality implementation */
  writeValue(value: any): void {
    if (value) {
      const zipParts = value.split('-');
      this.postalCodeForm.setValue({
        zip: zipParts[0],
        zipExtension: zipParts[1] || '',
      });
      this.emitValidationStatus();
    }
  }

  /** Register change event functionality */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /** Register on touch event functionlity */
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  /** Set field disable state */
  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.postalCodeForm.disable() : this.postalCodeForm.enable();
  }

  /** Emit validation status to parent */
  emitValidationStatus() {
    this.validationStatus.emit(this.postalCodeForm.valid);
  }
}